import { AUTH_STATE_REQUESTED, AUTH_STATE_STARTED_LISTENING, } from '../constants/events';
/**
 * @ignore
 */
function requestAuthState(callback) {
    window.dispatchEvent(new CustomEvent(AUTH_STATE_REQUESTED, {
        detail: {
            callback,
        },
    }));
}
/**
 * Get the current user's auth state
 *
 * @param callback - The callback to be called with the current user's auth state
 */
export function getAuthState(callback) {
    let called = false;
    function cb(profile) {
        if (!called) {
            called = true;
            callback(profile);
        }
    }
    window.addEventListener(AUTH_STATE_STARTED_LISTENING, () => {
        requestAuthState(cb);
    });
    requestAuthState(cb);
}
